import * as Yup from 'yup';

declare module 'yup' {
    export interface StringSchema {
        /**
         * Check for phone number validity.
         *
         * @param {String} [errorMessage=''] The error message to return if the validation fails.
         */
        phone(errorMessage?: string): StringSchema;
    }
}
declare module 'yup' {
    export interface NumberSchema {
        /**
         * Check for phone number validity.
         *
         * @param {String} [errorMessage=''] The error message to return if the validation fails.
         */
        phone(errorMessage?: string): NumberSchema;
    }
}

const YUP_PHONE_METHOD = 'phone';
const rePhoneNumber = /^(\+?\d{0,4})?\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{4}\)?)?$/;

const yupPhone = function yupPhone<T>(this: Yup.Schema<T>, errorMessage: string = ''): any {
    const errMsg = (typeof errorMessage === 'string' && errorMessage) || '';

    // @ts-ignore
    return this.test(YUP_PHONE_METHOD, errMsg, (value: string) => rePhoneNumber.test(value));
};

Yup.addMethod(Yup.string, YUP_PHONE_METHOD, yupPhone);
Yup.addMethod(Yup.number, YUP_PHONE_METHOD, yupPhone);
